import { ElementRef, Renderer2, inject } from "@angular/core";

import * as Plotly from 'plotly.js-dist-min'
import { environment } from "src/environments/environment";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { ChartWrapperComponent } from "./chart-wrapper/chart-wrapper.component";

export class ChartsCommonFunctions {

    isMobile() {
        return window.innerWidth <= 767;
    }

    isIframe(elementRef: ElementRef, renderer:Renderer2) {
        if (window.self !== window.top) {

            let chartContainer = elementRef.nativeElement.querySelector('#chartContainer')

            renderer.addClass(chartContainer, 'main-container-iframe')
            renderer.removeClass(chartContainer, 'main-container')

        }
    }

    getTextElements(prov_text_elements:any, profile:any) {
        let value = null
        let final_text_elements:any = {}
        if (profile.retailer && prov_text_elements['retailer']) {
            Object.keys(prov_text_elements['retailer']).forEach((key) => {

                if (profile) {
                value = prov_text_elements['retailer'][key];
                value = value.replace('[list short name]', profile.current_list?.name);
                value = value.replace('[list long name]', profile.current_list?.long_name);
                value = value.replace('[number of retailers]', profile.current_list?.public_corps_number);
                value = value.replace('[retailer print name]', profile.retailer?.name);
                value = value.replace('[common region name]',  profile.current_list?.region.name)
                value = value.replace('[label name]', profile.current_list?.label)
                value = value.replace('[corporation name]', profile.retailer?.corporation?.name)
                //TODO add list [label name] to list and retailer

                //Fill out new text element object
                //prov_text_elements['retailer'][key] = value;
                final_text_elements[key] = value
                }
            })
        } else if (profile.listProfile && profile.listProfile['current_list'] && prov_text_elements['list']) {
            Object.keys(prov_text_elements['list']).forEach((key) => {
                value = prov_text_elements['list'][key];

                value = value.replace('[list short name]', profile.listProfile?.current_list?.name);
                value = value.replace('[list long name]', profile.listProfile?.current_list?.long_name);
                value = value.replace('[number of retailers]', profile.listProfile?.current_list?.public_corps_number);
                value = value.replace('[common region name]',  profile.listProfile?.current_list?.region.name);
                value = value.replace('[label name]', profile.listProfile?.current_list?.label)

                //Fill out new text element object
                final_text_elements[key] = value
                }
            )}
        //console.log(profile.listProfile)
        //console.log(prov_text_elements['list'])
        if (value !== null) { //return the updated object
            return final_text_elements
        } else { //return the original if the updated hasn't been modified
            return prov_text_elements
        }
    }

    barChartDynamicLeftMargin(chartData:any) {

        let chart_data = chartData.data[0]

        let stringLengths = chart_data.y.map((i:any) => {return i.length})

        let longest = Math.max(...stringLengths)

        return longest*7.2

      }

    checkListOrRetailer(model:any, //TODO: listprofile and retailerprofile appear as undefined even when passed as parameters. Fix if time
        profile:any,
        current_list:any,
        listprofile?:any,
        retailerprofile?:any){

    if (model.indexOf('List') !== -1 ) {

        return {
            profile: listprofile,
            current_list: profile.listProfile.current_list
        }
      } else {
        return {
            profile:retailerprofile,
            current_list:profile.current_list
        }
      }
    }

    subscribeToUserEvents(this:ChartsCommonFunctions, plot:any, chartWrapper:ChartWrapperComponent) {

        function handleUserEvent(this:ChartsCommonFunctions){


            if (!chartWrapper.hasBeenWarned) {
                chartWrapper.hasBeenWarned = true;
                chartWrapper.showWarning = true;

                setTimeout(() => {
                    chartWrapper.showWarning = false
                }, 5000)
            }

        }

        plot.on('plotly_restyle', handleUserEvent)
        plot.on('plotly_relayout', handleUserEvent)
    }


    removeCircularReferences(obj: any) {
      const seen = new WeakSet(); // Keeps track of already seen objects
      return JSON.parse(
        JSON.stringify(obj, (key, value) => {
          if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
              return; // Avoid circular reference by returning undefined
            }
            seen.add(value);
          }
          return value;
        })
      );
    }
}
